import axios from "axios";

const getOrdersFromServer = async (authToken) => {
    try {
        const response = await axios.get("/api/user/orders", {
            headers: { authorization: authToken },
        });
        if (response.status === 200) {
            return response.data;
        } else {
            throw new Error();
        }
    } catch (e) {
        console.error("getOrdersFromServer : Error in fetching order history", e);
    }
};

const addToOrdersInServer = async (authToken, order) => {
    try {
        const response = await axios.post(
            "/api/user/orders",
            { order },
            {
                headers: { authorization: authToken },
            }
        );
        if (response.status === 201) {
            return response.data;
        } else {
            throw new Error();
        }
    } catch (e) {
        console.error("addToOrdersInServer : Error in placing order", e);
    }
};

export { getOrdersFromServer, addToOrdersInServer };